// Waluta konta (`currency` w /profile): jedna dla wszystkich kwot — Portfel, Finanse, ceny
// w Jedzeniu i Koszyku. Zmiana niczego nie przelicza, tylko zmienia zapis. Stan jest wspólny:
// ustawia go wczytanie profilu (useMenu) i zmiana w Ustawieniach → Profil; do tego czasu
// obowiązuje ostatnio znana waluta tego urządzenia, żeby kwoty nie mrugały „zł".
import { ref } from 'vue';
import { intlLocale } from '@/composables/useLanguage.js';
import { t } from '@/i18n/index.js';

export const CURRENCIES = [
    { value: 'PLN', get label() { return t('settings.currencies.PLN'); } },
    { value: 'EUR', get label() { return t('settings.currencies.EUR'); } },
    { value: 'GBP', get label() { return t('settings.currencies.GBP'); } },
    { value: 'USD', get label() { return t('settings.currencies.USD'); } },
    { value: 'CHF', get label() { return t('settings.currencies.CHF'); } },
    { value: 'CZK', get label() { return t('settings.currencies.CZK'); } },
    { value: 'SEK', get label() { return t('settings.currencies.SEK'); } },
    { value: 'NOK', get label() { return t('settings.currencies.NOK'); } },
    { value: 'DKK', get label() { return t('settings.currencies.DKK'); } },
    { value: 'CAD', get label() { return t('settings.currencies.CAD'); } },
    { value: 'AUD', get label() { return t('settings.currencies.AUD'); } },
];

const KEY = 'rountine.currency';
const known = (code) => CURRENCIES.some(c => c.value === code);
const stored = () => { try { return localStorage.getItem(KEY); } catch { return null; } };

export const currency = ref(known(stored()) ? stored() : 'PLN');

export const setCurrency = (code) => {
    if (!known(code)) return;
    currency.value = code;
    try { localStorage.setItem(KEY, code); } catch { /* zostaje do końca sesji */ }
};

const formatters = new Map();
// Po angielsku złotówki kodem („PLN 12.50"), inne waluty symbolem („£12.50").
const formatter = (digits) => {
    const locale = intlLocale();
    const key = `${locale}/${currency.value}/${digits}`;
    if (!formatters.has(key)) {
        formatters.set(key, new Intl.NumberFormat(locale, {
            style: 'currency', currency: currency.value,
            currencyDisplay: locale !== 'pl-PL' && currency.value === 'PLN' ? 'code' : 'narrowSymbol',
            minimumFractionDigits: digits, maximumFractionDigits: digits,
        }));
    }
    return formatters.get(key);
};

// Kwota w całych jednostkach waluty → „1200,00 zł", „12,50 €", „3 £" (digits = 0).
export const formatMoney = (value, digits = 2) => formatter(digits).format(Number(value) || 0);

// Sam symbol: „zł", „€", „£" — do etykiet pól i osi.
export const currencySymbol = () =>
    formatter(0).formatToParts(0).find(p => p.type === 'currency')?.value ?? currency.value;
